
import { Vue } from "vue-class-component";

export default class Bkd extends Vue {}
